module.exports = __webpack_public_path__ + "static/media/triton-sidebar.f1f6d879.jpg";